"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePropertyPolicyDiscountType = exports.PropertyPolicyDiscountTypes = void 0;
const zod_1 = require("zod");
const CommonDiscountTypes_1 = require("../enums/CommonDiscountTypes");
const PropertyPolicyDiscounts_1 = require("../enums/PropertyPolicyDiscounts");
exports.PropertyPolicyDiscountTypes = Object.assign({}, PropertyPolicyDiscounts_1.PropertyPolicyDiscounts, CommonDiscountTypes_1.CommonDiscounts);
exports.impossiblePropertyPolicyDiscountType = zod_1.z.union([zod_1.z.nativeEnum(CommonDiscountTypes_1.CommonDiscounts), zod_1.z.nativeEnum(PropertyPolicyDiscounts_1.PropertyPolicyDiscounts)]);
